document.addEventListener('DOMContentLoaded', () => {
  const shell = document.querySelector('.devico-policy-shell');
  if (!shell) return;
  const body = shell.querySelector('.shopify-policy__body');
  const toc = shell.querySelector('[data-policy-toc]');
  const time = shell.querySelector('[data-policy-reading-time]');
  if (!body || !toc) return;

  const headings = [...body.querySelectorAll('h2, h3')].filter(h => h.textContent.trim());
  const slugify = text => text.toLowerCase().trim().replace(/[^a-z0-9\s-]/g, '').replace(/\s+/g, '-').replace(/-+/g, '-');

  headings.forEach((heading, index) => {
    if (!heading.id) heading.id = `devico-policy-${slugify(heading.textContent) || index + 1}`;
    const link = document.createElement('a');
    link.href = `#${heading.id}`;
    link.textContent = heading.textContent.trim();
    link.dataset.level = heading.tagName === 'H3' ? '3' : '2';
    toc.appendChild(link);
  });

  if (time) {
    const words = body.textContent.trim().split(/\s+/).filter(Boolean).length;
    time.textContent = `${Math.max(1, Math.ceil(words / 220))} MIN`;
  }

  if (!headings.length) {
    toc.closest('.devico-policy-sidebar__sticky')?.classList.add('devico-policy-sidebar__sticky--no-toc');
    toc.innerHTML = '<span class="eyebrow">FULL POLICY BELOW</span>';
    return;
  }

  const links = [...toc.querySelectorAll('a')];
  const setActive = id => links.forEach(link => link.classList.toggle('is-active', link.getAttribute('href') === `#${id}`));
  const observer = new IntersectionObserver(entries => {
    const visible = entries.filter(entry => entry.isIntersecting).sort((a,b) => a.boundingClientRect.top - b.boundingClientRect.top);
    if (visible[0]) setActive(visible[0].target.id);
  }, { rootMargin: '-110px 0px -65% 0px', threshold: 0 });
  headings.forEach(h => observer.observe(h));

  links.forEach(link => {
    link.addEventListener('click', event => {
      const target = document.getElementById(link.getAttribute('href').slice(1));
      if (!target) return;
      event.preventDefault();
      target.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
      history.replaceState(null, '', `#${target.id}`);
    });
  });
});
